import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: '⬇️ Téléchargement instantané',
  desc: "Achetez et obtenez un accès immédiat à l'ebook complet et à l'ensemble des 5 bonus. Commencez quand vous le souhaitez, pas d'attente."
}, {
  n: '2',
  title: '👁️ Suivez la méthode visuelle',
  desc: 'Apprenez le Hangeul, la prononciation, le vocabulaire et les phrases dans un ordre conçu pour que vous ne vous perdiez jamais. Le système est votre feuille de route.'
}, {
  n: '3',
  title: '🎯 Complétez la routine de 60 minutes',
  desc: 'Étudiez étape par étape, pratiquez ce que vous avez appris et consolidez votre mémoire pour parler avec une vraie confiance en 60 minutes.'
}];
export function Steps() {
  return <section aria-label="Comment ça marche" className="bg-transparent" data-id="element-175" data-mp="2624t1jxw0v7n">
      <div className="mx-auto max-w-4xl px-5 py-12" data-id="element-176" data-mp="25zqydc74dl0m">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-177" data-mp="2a3qazjpa3zop">
          Comment vous progresserez dès aujourd'hui
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-178" data-mp="1q8zhkvowlejz">En 3 étapes simples</p>

        <ol className="mt-10 space-y-4" data-id="element-179" data-mp="1la6ezyb5n7yl">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-180" data-mp="200lztbznsdw8" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-181" data-mp="1hc8nupxtqbsk">
                {s.n}
              </span>
              <div data-id="element-182" data-mp="2soht06q0rno9">
                <h3 className="text-base font-bold text-plum" data-id="element-183" data-mp="2snzrovoi2j9h">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-184" data-mp="2npy889n5whxh">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}